import { format, isValid } from "date-fns";

export const preventInvalidKey = (e: any) => {
  const invalidKeys = ['e', 'E', '+', '-', '.'];
  if (invalidKeys.includes(e.key)) {
    e.preventDefault();
  }
};


export const dateFormat = 'dd-MM-yyyy';
export const timeFormat = 'hh:mm a';
export const dateTimeFormat = 'dd-MM-yyyy hh:mm a';

const parseSafeDate = (input: string | Date): Date | null => {
  if (!input) return null;

  if (input instanceof Date) {
    return isValid(input) ? input : null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [year, month, day] = input.split("-");
    return new Date(Number(year), Number(month) - 1, Number(day));
  }
  const dateString =
    /^\d{4}-\d{2}-\d{2}T/.test(input) &&
      !input.endsWith("Z") &&
      !/[+-]\d{2}:\d{2}$/.test(input)
      ? `${input}Z`
      : input;


  const parsed = new Date(dateString);
  return isValid(parsed) ? parsed : null;
};


const formatSafe = (value: string | Date | undefined | null, pattern: string) => {
  if (!value) return '--';

  const parsed = parseSafeDate(value);
  if (!parsed) return '--';

  return format(parsed, pattern);
};

export const stripHtml = (html: string) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};
export const showDate = (date: string | Date | undefined | null) =>
  formatSafe(date, dateFormat);

export const showTime = (time: string | Date | undefined | null) =>
  formatSafe(time, timeFormat);

export const showDateTime = (dateTime: string | Date | undefined | null) =>
  formatSafe(dateTime, dateTimeFormat);

export const showTimeForHistory = (
  time: string | Date | undefined | null
) => {
  if (!time) return "";

  // HH:mm:ss format
  if (typeof time === "string" && /^\d{2}:\d{2}:\d{2}$/.test(time)) {
    const today = new Date().toISOString().split("T")[0];

    const utcDate = new Date(`${today}T${time}Z`);

    return utcDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  return formatSafe(time, timeFormat);
};